export default __webpack_public_path__ + "static/media/coin_flip_decision_3.8aef46fb.png";